
import _, { result } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../redux/library/selector';
import Table from '../../../../../common/components/table';


export const MarketPlacePolicyVendorComponent = ({
    id,
    selectedPolicyCollections,
    setSelectedPolicyCollections,
    vendors,
    closeModal,
    setSelectedVendors
}: any) => {
    const [currentVendors, setCurrentVendors] = useState<any>([]);
    const libraryData = useSelector(selectListItems)
    
    const [
        columnDefs,
        setColumnDefs
    ] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'AccountInfo.AccountName', headerName: 'AccountName' },
            { field: 'AccountInfo.Email', headerName: 'Email' },
            { field: 'AccountInfo.Phone', headerName: 'Phone' },
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
        ]);
    }

    useEffect(() => {
        createColumnDefs();
    }, []);

    const handleSelect = (item: any, checked: any) => {
        const selectedItems = _.find(selectedPolicyCollections?.Marketplaces?.EntityIds, (id: number) => {
            console.log(id, item.Id);
            return id === item.VendorId;
        });
        if (checked && !selectedItems) {
            setCurrentVendors([...currentVendors, item]);
        } else if (!checked && selectedItems) {
            // Remove item from the collection
            const newItems = _.map(selectedPolicyCollections?.Marketplaces?.EntityIds, (id: number) => id !== item.VendorId);
            setCurrentVendors(newItems);
        } else {
            // setCurrentVendors(selectedPolicyCollections?.Collections?.EntityIds);
            console.log('Already present. doing nothing.')
        }
    }

    const handleSelectAll = (items: any[], checked: any) => {
        console.log("Items count", checked, items?.length)
        console.log('items', items)
    }

    const handleSelectVendors = () => {

        const entityIds = [];
        const mapToEntity = _.map(currentVendors, (vendor: any)=>{ 
            entityIds.push(vendor.VendorId);  
            return ({     
                "EntityTypeId": 41,
                "EntityTypeName": "Vendor",
                "EntityId": vendor.VendorId,
                "EntityName": vendor.Name,
                "MediaMappings": vendor.MediaMappings
            })
        })

        setSelectedPolicyCollections({
            ...selectedPolicyCollections,
            Marketplaces: {
              ...selectedPolicyCollections.Marketplaces,
              EntityIds: entityIds
            }
          });
          
        setSelectedVendors(mapToEntity)
        closeModal();
      }

    return (
        <>
            <Table
                columnData={columnDefs}
                rowData={vendors}
                onSelect={handleSelect} onSelectAll={handleSelectAll}
                enableFilter={true}
                headingName="Vendors"
            />   
            <div className='flex w-full justify-end items-end'>
                <button
                onClick={closeModal}
                type='button'
                className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                Close
                </button>
                <button
                className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                onClick={handleSelectVendors}

                type="submit"
                >
                Save
                </button>
            </div>                        
        </>
    )
}

export default MarketPlacePolicyVendorComponent;
